import { render, staticRenderFns } from "./EditTalkDialog.vue?vue&type=template&id=3577e42d&scoped=true"
import script from "./EditTalkDialog.vue?vue&type=script&lang=js"
export * from "./EditTalkDialog.vue?vue&type=script&lang=js"
import style0 from "./EditTalkDialog.vue?vue&type=style&index=0&id=3577e42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3577e42d",
  null
  
)

export default component.exports